/**
 * UUIDv7 — sortabilan po vremenu, radi u Workers i u React Native.
 * D1 nema ugrađenu funkciju pa se generira u aplikaciji.
 */
export function uuidv7(now: number = Date.now()): string {
  const bytes = new Uint8Array(16);
  /*
    Poruka umjesto zagonetne greške: React Native nema `crypto`, pa je ovo
    padalo na telefonu s „Property 'crypto' doesn't exist" duboko u redu
    čekanja, bez traga odakle. Mobilna aplikacija zakrpu postavlja u
    `src/lib/installCrypto.ts`.
  */
  if (typeof crypto === 'undefined' || typeof crypto.getRandomValues !== 'function') {
    throw new Error('uuidv7 traži crypto.getRandomValues, a runtime ga nema');
  }
  crypto.getRandomValues(bytes);

  // 48 bita timestamp (ms)
  bytes[0] = (now / 2 ** 40) & 0xff;
  bytes[1] = (now / 2 ** 32) & 0xff;
  bytes[2] = (now / 2 ** 24) & 0xff;
  bytes[3] = (now / 2 ** 16) & 0xff;
  bytes[4] = (now / 2 ** 8) & 0xff;
  bytes[5] = now & 0xff;

  // verzija 7 i varijanta RFC 4122
  bytes[6] = (bytes[6]! & 0x0f) | 0x70;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;

  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/** Idempotency ključ za offline zapise — isti ključ dvaput ne stvara duplikat. */
export const newIdempotencyKey = (): string => uuidv7();
